/*@ngInject*/
const FormUpgradeCheckRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.submissionFormsNeedsUpgrade = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/upgradeFormsRequired';

        return this.get(url);
    };

    this.accountFormsNeedsUpgrade = function (accountId) {
        var url = '/rest/Account/' + accountId + '/upgradeFormsRequired';

        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('formUpgradeCheckRepository', FormUpgradeCheckRepository);
